<template>
  <div
    id="init-home-container"
    class="d-flex flex-column justify-center align-center"
    style="width: 100dvw; max-width: 100dvw"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <auth></auth>
    <v-dialog v-model="show_art_diag" style="z-index: 5000">
      <v-card
        elevation="=2"
        class="wellbeing"
        style="max-width: 1025px; margin: auto"
      >
        <v-card-title class="white--text">{{
          art_diag.art_diag_box_title
        }}</v-card-title>
        <v-card-text>
          <v-form v-model="valid" class="white">
            <v-container>
              <v-text-field
                v-model="art_diag.article.title"
                maxlength="60"
                :counter="60"
                :label="art_diag.art_field_label"
                :hint="art_diag.placeholder"
                required
              ></v-text-field>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="save_art_title"
          >
            <v-icon small>$save</v-icon>
            Save</v-btn
          >
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="cancel_art_title"
          >
            <v-icon small>$cancel1</v-icon>
            Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_hdr_diag" style="z-index: 5000">
      <v-card
        elevation="=2"
        class="wellbeing"
        style="max-width: 1025px; margin: auto"
      >
        <v-card-title class="white--text">{{
          hdr_diag.box_title
        }}</v-card-title>
        <v-card-text>
          <v-form v-model="valid" class="white">
            <v-container>
              <v-text-field
                v-model="hdr_diag.hdr.title"
                maxlength="60"
                :counter="60"
                :label="hdr_diag.field_label"
                :hint="hdr_diag.placeholder"
                required
              ></v-text-field>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="save_hdr_title"
          >
            <v-icon small>$save</v-icon>
            Save</v-btn
          >
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="cancel_hdr_title"
          >
            <v-icon small>$cancel1</v-icon>
            Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      id="ti_daig"
      v-model="show_ti_diag"
      elevation="0"
      content-class="elevation-0"
      style="z-index: 5000"
    >
      <v-card
        elevation="=2"
        class="black"
        style="max-width: 1025px; margin: auto"
      >
        <v-card-title class="white--text">{{ ti_diag.box_title }}</v-card-title>
        <v-card-text>
          <tiptap
            key="n42"
            v-model="ti_diag.text_current.text_content"
            :characterLimit="editorLimit"
            :htmlLimit="editorLimit"
            :update_tiptap="update_tiptap"
          ></tiptap>
        </v-card-text>
        <!-- <v-card-text>
          <v-form v-model="valid" class="white">
            <v-container>
              <v-textarea
                name="input-7-1"
                label="Tip Tap Editor Goes here"
                v-model="ti_diag.text_content"
              ></v-textarea>
            </v-container>
          </v-form>
        </v-card-text> -->
        <v-card-actions>
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="save_ti_edit"
          >
            <v-icon small>$save</v-icon>
            Save</v-btn
          >
          <v-btn
            small
            elevation="2"
            class="blue accent-3 white--text"
            @click="cancel_ti_edit"
          >
            <v-icon small>$cancel1</v-icon>
            Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-spacer></v-spacer>
    <v-main id="main_content_prime" class="page-size">
      <peer
        v-if="tabs == 'peer'"
        :update_peer="update_peer"
        :peer_panel_open="peer_panel_open"
        @edit_ti="edit_ti"
        @ti_add_up="ti_add_up"
        @ti_add_below="ti_add_below"
        @ti_move_below="ti_move_below"
        @ti_move_up="ti_move_up"
        @ti_del="ti_del"
        @ti_add_first="ti_add_first"
        @hdr_edit="hdr_edit"
        @hdr_move_up="hdr_move_up"
        @hdr_move_down="hdr_move_down"
        @hdr_add_up="hdr_add_up"
        @hdr_add_below="hdr_add_below"
        @hdr_add_first="hdr_add_first"
        @hdr_del="hdr_del"
        @art_add_first="art_add_first"
        @art_edit="art_edit"
        @art_move_up="art_move_up"
        @art_move_down="art_move_down"
        @art_add_down="art_add_down"
        @art_add_up="art_add_up"
        @art_del="art_del"
      ></peer>
      <physical
        v-if="tabs == 'physical'"
        :update_physical="update_physical"
        @edit_ti="edit_ti"
        @ti_add_up="ti_add_up"
        @ti_add_below="ti_add_below"
        @ti_move_below="ti_move_below"
        @ti_move_up="ti_move_up"
        @ti_del="ti_del"
        @ti_add_first="ti_add_first"
        @hdr_edit="hdr_edit"
        @hdr_move_up="hdr_move_up"
        @hdr_move_down="hdr_move_down"
        @hdr_add_up="hdr_add_up"
        @hdr_add_below="hdr_add_below"
        @hdr_add_first="hdr_add_first"
        @hdr_del="hdr_del"
        @art_add_first="art_add_first"
        @art_edit="art_edit"
        @art_move_up="art_move_up"
        @art_move_down="art_move_down"
        @art_add_down="art_add_down"
        @art_add_up="art_add_up"
        @art_del="art_del"
      ></physical>
      <spiritual
        v-if="tabs == 'spiritual'"
        :update_spiritual="update_spiritual"
        @edit_ti="edit_ti"
        @ti_add_up="ti_add_up"
        @ti_add_below="ti_add_below"
        @ti_move_below="ti_move_below"
        @ti_move_up="ti_move_up"
        @ti_del="ti_del"
        @ti_add_first="ti_add_first"
        @hdr_edit="hdr_edit"
        @hdr_move_up="hdr_move_up"
        @hdr_move_down="hdr_move_down"
        @hdr_add_up="hdr_add_up"
        @hdr_add_below="hdr_add_below"
        @hdr_add_first="hdr_add_first"
        @hdr_del="hdr_del"
        @art_add_first="art_add_first"
        @art_edit="art_edit"
        @art_move_up="art_move_up"
        @art_add_down="art_add_down"
        @art_del="art_del"
      ></spiritual>
      <mental
        v-if="tabs == 'mental'"
        :update_mental="update_mental"
        :mental_panel_open="mental_panel_open"
        @edit_ti="edit_ti"
        @ti_add_up="ti_add_up"
        @ti_add_below="ti_add_below"
        @ti_move_below="ti_move_below"
        @ti_move_up="ti_move_up"
        @ti_del="ti_del"
        @ti_add_first="ti_add_first"
        @hdr_edit="hdr_edit"
        @hdr_move_up="hdr_move_up"
        @hdr_move_down="hdr_move_down"
        @hdr_add_up="hdr_add_up"
        @hdr_add_below="hdr_add_below"
        @hdr_add_first="hdr_add_first"
        @hdr_del="hdr_del"
        @art_add_first="art_add_first"
        @art_edit="art_edit"
        @art_move_up="art_move_up"
        @art_move_down="art_move_down"
        @art_add_down="art_add_down"
        @art_add_up="art_add_up"
        @art_del="art_del"
      ></mental>
      <resil
        v-if="tabs == 'resil'"
        :update_resil="update_resil"
        :resil_panel_open="resil_panel_open"
        @edit_ti="edit_ti"
        @ti_add_up="ti_add_up"
        @ti_add_below="ti_add_below"
        @ti_move_below="ti_move_below"
        @ti_move_up="ti_move_up"
        @ti_del="ti_del"
        @ti_add_first="ti_add_first"
        @hdr_edit="hdr_edit"
        @hdr_move_up="hdr_move_up"
        @hdr_move_down="hdr_move_down"
        @hdr_add_up="hdr_add_up"
        @hdr_add_below="hdr_add_below"
        @hdr_add_first="hdr_add_first"
        @hdr_del="hdr_del"
        @art_add_first="art_add_first"
        @art_edit="art_edit"
        @art_move_up="art_move_up"
        @art_move_down="art_move_down"
        @art_add_down="art_add_down"
        @art_add_up="art_add_up"
        @art_del="art_del"
      ></resil>
    </v-main>
    <v-spacer></v-spacer>
    <auth></auth>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  a {
    color: rgb(0, 55, 255) !important;
    text-decoration: underline;
    font-weight: 600;
  }
  .w100 {
    width: 100%;
  }
  .page-init-height {
    min-height: 100dvh;
  }
  .page-size {
    width: 100%;
    max-width: 1025px;
    height: auto;
    margin-top: 120px;
  }
  .pagedown {
    margin-top: 123px;
  }
  .tool-label {
    font-size: 0.85rem;
  }
  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .page-size {
    width: 100%;
    max-width: 1025px;
    height: auto;
    margin-top: 168px;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
.v-dialog.v-dialog--active {
  box-shadow: none !important;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import peer from "../components/peer.vue";
// import { mdiAbugidaThai } from "@mdi/js";
const spiritual = () => import("./spiritual.vue");
const physical = () => import("./physical.vue");
const mental = () => import("./mental.vue");
const resil = () => import("./resil.vue");
const tiptap = () => import("./tiptap.vue");
const auth = () => import("./auth.vue");

//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: { peer, tiptap, spiritual, physical, auth, mental, resil },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      update_tiptap: null,
      texttemp: "drag",
      update_peer: null,
      update_spiritual: null,
      update_physical: null,
      update_mental: null,
      update_resil: null,
      scroll_pos: 0,
      panel_index: 0,
      peer_panel_open: -1,
      mental_panel_open: -1,
      resil_panel_open: -1,
      editorLimit: 7999,
      ti_edit: {},
      ti_diag: {
        field_label: "Text",
        box_title: "Edit Text ",
        title: "",
        ti_prev_next: "",
        text_current: {},
        placeholder: "",
        og_text: "",
        og_order: 0,
        rsrc: "",
        panel: -1,
      },
      art_diag: {
        art_field_label: "Article Title",
        art_diag_box_title: "Edit Article Title",
        art_prev_next: "",
        article: {},
        placeholder: "",
        rsrc: "",
      },
      hdr_diag: {
        field_label: "Header Title",
        box_title: "Edit Header Title",
        hdr_prev_next: 0,
        hdr: { header: { title: "never seen" } },
        placeholder: "",
        resource_type: "",
        operation: "",
      },
      valid: true,
      show_art_diag: false,
      show_hdr_diag: false,
      show_ti_diag: false,
      doc: {},
      descr_text: "Welcome Text Goes here",
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
    panel_open() {
      this.panel_index = this.panel_open;
    },
  },
  computed: {
    tabs() {
      return this.$store.state.tabs;
    },
    show_admin_controls() {
      return this.$store.state.show_admin_controls;
    },
    show_user_controls() {
      return this.$store.state.show_user_controls;
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    //jm stuff
    cancel_ti_edit() {
      this.ti_text = "";
      this.show_ti_diag = false;
      setTimeout(() => {
        document.getElementById("vapp").scrollTop = this.scroll_pos;
      }, 500);
    },
    ti_del_now(pl) {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.text_itemId = pl.ti.text_itemId;

      formIn.apiname = "ti_del_now";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //   self.mrbreakpoint("dman");
          if (pl.ti.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (pl.ti.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (pl.ti.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (pl.ti.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (pl.ti.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    ti_del(payload) {
      var pl = payload;
      var self = this;
      this.swall_diag(
        "Confirm delete",
        "Continue to delete text item that begins with ''" +
          self.leftStr(self.stripHtml(pl.ti.text_content), 20) +
          "'",
        "question",
        function () {
          self.ti_del_now(pl);
        },
        null,
        null,
        null
      );
    },
    move_ti() {
      //   this.mrbreakpoint("save_ti_edit");
      var self = this;
      this.ti_text = "";
      this.show_ti_diag = false;
      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.ti = this.mno(this.ti_diag);
      formIn.hdr = this.mno(this.ti_diag.header_current.header);

      if (formIn.ti.text_current.text_content.indexOf("<p>") == -1) {
        this.swall_it(
          "Cannot Save yet",
          "Please edit the text before trying to save.",
          "error",
          null,
          null
        );
        return true;
      }

      formIn.apiname = "move_ti";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("data fdown");
          if (formIn.ti.text_current.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.ti.text_current.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.ti.text_current.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.ti.text_current.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.ti.text_current.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    save_ti_edit() {
      //   this.mrbreakpoint("save_ti_edit");
      var self = this;
      this.ti_text = "";
      this.show_ti_diag = false;
      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.ti = this.mno(this.ti_diag);
      formIn.hdr = this.mno(this.ti_diag.header_current.header);
      //console.log("Save ti edit test: " + formIn.ti.text_current.text_content);
      if (formIn.ti.text_current.text_content.indexOf("<p>") == -1) {
        // this.swall_it(
        //   "Cannot Save yet",
        //   "Please edit the text before trying to save.",
        //   "error",
        //   null,
        //   null
        // );
        formIn.ti.text_current.text_content =
          "<p>" + formIn.ti.text_current.text_content + "</p>";
        //return true;
      }

      formIn.apiname = "save_ti_edit";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (formIn.ti.text_current.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.ti.text_current.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.ti.text_current.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.ti.text_current.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.ti.text_current.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    cancel_hdr_title() {
      // save_hdroperation;
      // this.hdr_diag_title = "";
      this.show_hdr_diag = false;
    },
    hdr_update_now(formIn) {
      if (formIn.hdr_diag.resource_type == "peer") {
        self.update_peer = new Date();
      }
      if (formIn.hdr_diag.resource_type == "physical") {
        self.update_physical = new Date();
      }
      if (formIn.hdr_diag.resource_type == "spiritual") {
        self.update_spiritual = new Date();
      }
      if (formIn.hdr_diag.resource_type == "mental") {
        self.update_mental = new Date();
      }
      if (formIn.hdr_diag.resource_type == "resil") {
        self.update_resil = new Date();
      }
    },
    hdr_update_now2(formIn) {
      if (formIn.resource_type == "peer") {
        self.update_peer = new Date();
      }
      if (formIn.resource_type == "physical") {
        self.update_physical = new Date();
      }
      if (formIn.resource_type == "spiritual") {
        self.update_spiritual = new Date();
      }
      if (formIn.resource_type == "mental") {
        self.update_mental = new Date();
      }

      if (formIn.resource_type == "resil") {
        this.update_resil = new Date();
      }
    },
    hdr_del(payload) {
      var pl = payload;
      var self = this;
      this.swall_diag(
        "Confirm delete",
        "Continue to delete Header that begins with '" +
          self.leftStr(self.stripHtml(pl.hdr.header.title), 20) +
          "'",
        "question",
        function () {
          self.hdr_del_now(pl);
        },
        null,
        null,
        null
      );
    },
    hdr_del_now(pl) {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.headerId = pl.hdr.header.headerId;

      formIn.apiname = "hdr_del_now";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          // self.mrbreakpoint("delhdr");
          if (pl.hdr.header.resource_type == "peer") {
            this.update_peer = new Date();
          }
          if (pl.hdr.header.resource_type == "physical") {
            this.update_physical = Math.floor(Math.random() * 10000000) + 1;
          }
          if (pl.hdr.header.resource_type == "spiritual") {
            this.update_spiritual = new Date();
          }
          if (pl.hdr.header.resource_type == "mental") {
            this.update_mental = new Date();
          }
          if (pl.hdr.header.resource_type == "resil") {
            this.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    hdr_add_first(payload) {
      let pl = this.mno(payload);
      console.log("hdr_add_first:");

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.art = this.mno(pl.art.article);
      formIn.resource_type = pl.rscr;

      formIn.apiname = "hdr_add_first";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (formIn.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.resource_type == "mental") {
            self.update_mental = new Date();
          }

          if (formIn.resource_type == "resil") {
            this.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    hdr_edit(payload) {
      //new

      let pl = this.mno(payload);
      let hdr = this.mno(pl.hdr.header);
      this.hdr_diag.field_label = "Header Title";
      this.hdr_diag.box_title = "Edit Header Title";
      this.hdr_diag.hdr_prev_next = 0;
      this.hdr_diag.hdr = hdr;
      this.hdr_diag.resource_type = pl.hdr.resource_type;
      this.hdr_diag.placeholder = "Edit Header Title Here";
      this.show_hdr_diag = true;
    },
    hdr_move() {
      this.hdr_diag_title = "";

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.hdr_diag = this.mno(this.hdr_diag);
      formIn.hdr_prev_next = this.hdr_diag.hdr_prev_next;

      formIn.apiname = "hdr_move";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("data fdown");
          if (formIn.hdr_diag.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.hdr_diag.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.hdr_diag.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.hdr_diag.resource_type == "mental") {
            self.update_mental = new Date();
          }

          if (formIn.hdr_diag.resource_type == "resil") {
            this.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    hdr_move_up(payload) {
      let pl = this.mno(payload);

      let hdr = this.mno(pl.hdr.header);
      this.hdr_diag.hdr_prev_next = -1;
      hdr.title = "";
      this.hdr_diag.hdr = hdr;
      this.hdr_diag.resource_type = pl.rsrc;
      this.hdr_diag.operation = "hdr_move";
      this.hdr_move();
    },
    hdr_move_down(payload) {
      let pl = this.mno(payload);
      console.log("hdr_move_down: " + pl.hdr.header.headerId);
      let hdr = this.mno(pl.hdr.header);
      this.hdr_diag.hdr_prev_next = 1;
      hdr.title = "";
      this.hdr_diag.hdr = hdr;
      this.hdr_diag.resource_type = pl.rsrc;
      this.hdr_diag.operation = "hdr_move";
      this.hdr_move();
    },
    hdr_add_up(payload) {
      //new
      let pl = this.mno(payload);
      console.log("hdr_add_up: " + pl.hdr.header.headerId);
      let hdr = this.mno(pl.hdr.header);
      this.hdr_diag.field_label = "Header Title";
      this.hdr_diag.box_title = "Insert Header Title";
      this.hdr_diag.hdr_prev_next = -1;
      hdr.title = "";
      this.hdr_diag.hdr = hdr;
      this.hdr_diag.resource_type = pl.rsrc;
      this.hdr_diag.placeholder = "Add Header Title Here";
      this.hdr_diag.operation = "hdr_insert";
      this.show_hdr_diag = true;
    },
    hdr_add_below(payload) {
      let pl = this.mno(payload);

      let hdr = this.mno(pl.hdr.header);
      this.hdr_diag.field_label = "Header Title";
      this.hdr_diag.box_title = "Insert Header Title";
      this.hdr_diag.hdr_prev_next = 1;
      hdr.title = "";
      this.hdr_diag.hdr = hdr;
      this.hdr_diag.resource_type = pl.rsrc;
      this.hdr_diag.placeholder = "Add Header Title Here";
      this.hdr_diag.operation = "hdr_insert";
      this.show_hdr_diag = true;
    },
    hdr_insert() {
      this.hdr_diag_title = "";
      this.show_hdr_diag = false;

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.hdr_diag = this.mno(this.hdr_diag);
      formIn.hdr_prev_next = this.hdr_diag.hdr_prev_next;

      formIn.apiname = "hdr_insert";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("hdr_insert");
          if (formIn.hdr_diag.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.hdr_diag.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.hdr_diag.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.hdr_diag.resource_type == "mental") {
            self.update_mental = new Date();
          }

          if (formIn.hdr_diag.resource_type == "resil") {
            this.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    ti_add_first(payload) {
      let pl = this.mno(payload);

      console.log("ti_add_first: " + pl.hdr.header.headerId);

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.hdr = this.mno(pl.hdr.header);
      //  this.mrbreakpoint(pl.hdr.header.headerId);
      formIn.resource_type = pl.rscr;

      formIn.apiname = "ti_add_first";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("ti_add_first fdown");
          console.log("ti_add_first_data_down");
          if (formIn.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.resource_type == "physical") {
            //console.log("Calling Physical update!");
            self.update_physical = new Date();
          }
          if (formIn.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    save_hdr_title() {
      if (this.hdr_diag.operation == "hdr_insert") {
        this.hdr_insert();
        return true;
      }
      this.hdr_diag_title = "";
      this.show_hdr_diag = false;

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.hdr = this.mno(this.hdr_diag.hdr);

      formIn.apiname = "save_hdr_edit";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("data fdown");
          if (formIn.hdr.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.hdr.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.hdr.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.hdr.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.hdr.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    cancel_art_title() {
      this.art_diag.article.title = "";
      this.show_art_diag = false;
    },
    art_del(payload) {
      var pl = payload;
      var self = this;
      this.swall_diag(
        "Confirm delete",
        "Continue to delete Article that begins with '" +
          self.leftStr(self.stripHtml(pl.article.title), 20) +
          "'",
        "question",
        function () {
          self.art_del_now(pl);
        },
        null,
        null,
        null
      );
    },
    art_del_now(pl) {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.articlesId = pl.article.articlesId;

      formIn.apiname = "art_del_now";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          // self.mrbreakpoint("delhdr");
          if (pl.article.resource_type == "peer") {
            this.update_peer = new Date();
          }
          if (pl.article.resource_type == "physical") {
            this.update_physical = Math.floor(Math.random() * 10000000) + 1;
          }
          if (pl.article.resource_type == "spiritual") {
            this.update_spiritual = new Date();
          }
          if (pl.article.resource_type == "mental") {
            this.update_mental = new Date();
          }
          if (pl.article.resource_type == "resil") {
            this.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    art_add_up(payload) {
      //this.(payload);
      var pl = this.mno(payload);

      this.art_diag.placeholder = "Enter New Article Title Here";
      this.art_diag.art_diag_box_title = "Add Article Above";

      this.art_diag.art_prev_next = -1;
      this.art_diag.article_current = pl.article;
      this.art_diag.rsrc = pl.rsrc;
      this.art_diag.operation = "art_insert";
      this.art_diag.article.title = "";

      this.show_art_diag = true;
    },
    art_add_down(payload) {
      var pl = this.mno(payload);

      this.art_diag.placeholder = "Enter New Article Title Here";
      this.art_diag.art_diag_box_title = "Add Article Above";

      this.art_diag.art_prev_next = 1;
      this.art_diag.article_current = pl.article;
      this.art_diag.rsrc = pl.rsrc;
      this.art_diag.operation = "art_insert";
      this.art_diag.article.title = "";

      this.show_art_diag = true;
    },
    art_move_up(payload) {
      let pl = this.mno(payload);
      console.log("art_move_up:");
      let art = this.mno(pl.article);
      this.art_diag.art_prev_next = -1;

      this.art_diag.article = art;
      this.art_diag.resource_type = pl.rsrc;
      this.art_diag.operation = "art_move";
      this.art_move(art, pl.rsrc, this.art_diag.art_prev_next);
    },
    art_move_down(payload) {
      let pl = this.mno(payload);
      console.log("art_move_down:");
      let art = this.mno(pl.article);
      this.art_diag.art_prev_next = 1;

      this.art_diag.article = art;
      this.art_diag.resource_type = pl.rsrc;
      this.art_diag.operation = "art_move";
      this.art_move(art, pl.rsrc, this.art_diag.art_prev_next);
    },
    art_move(art, rsrc, art_prev_next) {
      this.art_diag_title = "";

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.art = art;
      formIn.art_prev_next = art_prev_next;
      formIn.rsrc = rsrc;

      formIn.apiname = "art_move";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          // self.mrbreakpoint("data fdown");
          if (formIn.rsrc == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.rsrc == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.rsrc == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.rsrc == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.rsrc == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    art_insert() {
      this.art_diag_title = "";
      this.show_art_diag = false;

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);
      formIn.art_diag = this.mno(this.art_diag);
      formIn.art_prev_next = this.art_diag.art_prev_next;

      formIn.apiname = "art_insert";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.mrbreakpoint("data art save");
          if (formIn.art_diag.rsrc == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.art_diag.rsrc == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.art_diag.rsrc == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.art_diag.rsrc == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.art_diag.rsrc == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    save_art_title() {
      if (this.art_diag.operation == "art_insert") {
        this.art_insert();
        return true;
      }
      this.art_diag_title = "";
      this.show_art_diag = false;

      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.art = this.mno(this.art_diag.article);

      formIn.apiname = "save_art_title";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.get_doc();
          //self.mrbreakpoint("data art save");
          if (formIn.art.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.art.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.art.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.art.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.art.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    edit_ti(payload) {
      //capture the current Header for later saving TI
      //    this.();
      var pl = this.mno(payload);
      this.ti_diag.field_label = "Text";
      this.ti_diag.box_title = "Edit Text";

      this.ti_diag.ti_prev_next = -1;
      this.ti_diag.text_current = pl.ti;
      this.ti_diag.header_current = pl.hdr;
      this.ti_diag.rsrc = pl.rsrc;

      this.ti_diag.panel = payload.panel;

      this.ti_diag.placeholder = "Edit Text Here";

      this.scroll_pos = document.getElementById("vapp").scrollTop;
      this.update_tiptap = new Date();
      this.show_ti_diag = true;
    },
    ti_move_up(payload) {
      //this.mrbreakpoint(payload);

      var pl = this.mno(payload);
      this.ti_diag.ti_prev_next = -1;

      this.ti_diag.field_label = "Text";
      this.ti_diag.box_title = "Add New Text Above";

      this.ti_diag.text_current = pl.ti;
      console.log("edit text:" + pl.ti.text_content);
      this.ti_diag.header_current = pl.hdr;

      this.ti_diag.rsrc = pl.rsrc;

      this.ti_diag.placeholder = "Add Text Here";
      this.ti_diag.panel = payload.panel;
      this.scroll_pos = document.getElementById("vapp").scrollTop;
      this.update_tiptap = new Date();
      this.move_ti();
    },
    ti_move_below(payload) {
      //  this.mrbreakpoint(payload);
      var pl = this.mno(payload);
      // this.mrbreakpoint(pl.ti.order);
      this.ti_diag.ti_prev_next = 1;

      this.ti_diag.field_label = "Text";
      this.ti_diag.box_title = "Add New Text Above";

      this.ti_diag.text_current = pl.ti;
      console.log("edit text:" + pl.ti.text_content);
      this.ti_diag.header_current = pl.hdr;

      this.ti_diag.rsrc = pl.rsrc;

      this.ti_diag.placeholder = "Add Text Here";
      this.ti_diag.panel = payload.panel;
      this.scroll_pos = document.getElementById("vapp").scrollTop;
      this.move_ti();
    },
    ti_add_up(payload) {
      //this.mrbreakpoint(payload);

      var pl = this.mno(payload);
      this.ti_diag.ti_prev_next = pl.ti.order;
      pl.ti.text_itemId = 0;

      this.ti_diag.field_label = "Text";
      this.ti_diag.box_title = "Add New Text Above";

      this.ti_diag.text_current = pl.ti;
      console.log("edit text:" + pl.ti.text_content);
      this.ti_diag.header_current = pl.hdr;

      this.ti_diag.rsrc = pl.rsrc;

      this.ti_diag.placeholder = "Add Text Here";
      this.ti_diag.panel = payload.panel;
      this.scroll_pos = document.getElementById("vapp").scrollTop;
      this.update_tiptap = new Date();
      this.show_ti_diag = true;
    },

    ti_add_below(payload) {
      var pl = this.mno(payload);
      this.ti_diag.ti_prev_next = pl.ti.order + 1;
      pl.ti.text_itemId = 0;

      this.ti_diag.field_label = "Text";
      this.ti_diag.box_title = "Add New Text Above";

      this.ti_diag.text_current = pl.ti;
      console.log("edit text:" + pl.ti.text_content);
      this.ti_diag.header_current = pl.hdr;

      this.ti_diag.rsrc = pl.rsrc;

      this.ti_diag.placeholder = "Add Text Here";
      this.ti_diag.panel = payload.panel;
      this.scroll_pos = document.getElementById("vapp").scrollTop;
      this.update_tiptap = new Date();
      this.show_ti_diag = true;
    },
    art_add_first(payload) {
      let pl = this.mno(payload);
      console.log("art_add_first:" + pl.rscr);
      var self = this;

      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      // console.log("hdr_add_up: " + pl.hdr.header.headerId);

      formIn.resource_type = pl.rscr;

      formIn.apiname = "art_add_first";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (formIn.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
          if (formIn.resource_type == "mental") {
            self.update_mental = new Date();
          }
          if (formIn.resource_type == "resil") {
            self.update_resil = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    art_edit(payload) {
      var pl = this.mno(payload);
      console.log("Art_edit in home: " + pl.rsrc);
      this.art_diag.article = pl.article;
      this.art_diag.placeholder = "Enter Article Title Here";
      this.art_diag.art_diag_box_title = "Edit Article";
      this.art_diag.field_label = "Article Title";

      this.art_diag.placeholder = "Edit Article Title Here";
      this.art_diag.art_prev_next = 0;

      this.art_diag.resource_type = pl.rsrc;

      this.show_art_diag = true;
    },

    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      return true;
      var self = this;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            //   window.scroll(0, 3500);
            console.log(targetID);
            const daWindow = document.getElementById("vapp");
            const element = document.getElementById(targetID);
            element.scrollIntoView({ behavior: "smooth" });
          },
          500,
          targetID
        );
      }
    },
    get_doc() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      var tabnow = this.$store.state.tabs;
      this.$store.commit("set_tabs", "");
      var pnl = this.pan;

      formIn.apiname = "get_doc";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.doc = self.mno(data);
          setTimeout(() => {
            this.$store.commit("set_tabs", tabnow);
            this.show_loader(false);
          }, 200);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    init(self) {
      setTimeout(() => {
        this.update_peer = new Date();
        this.update_physical = Math.floor(Math.random() * 10000000) + 1;
        this.update_spiritual = new Date();
      }, "100");
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
